<div class="flex flex-row items-center gap-4">
@for (link of links; track link) {
    <div class="footer-link">
        @if (link.routerLink) {
            <a [routerLink]="link.routerLink">{{link.title}}</a>
        }
        @else {
            <a [href]="link.url">{{link.title}}</a>
        }
    </div>
}
<div>
